import { QueryClient } from '@tanstack/react-query';

/**
 * App-wide TanStack Query client (non-GraphQL state).
 *
 * A module singleton — mirroring `apolloClient` — so non-provider code can
 * reach it directly. `WorkspaceHydrator` needs it to `clear()` the cache on
 * a tenant change, but it renders ABOVE `QueryClientProvider`, so it can't
 * read the client through `useQueryClient()`. The singleton resolves that
 * without re-nesting the provider tree. `Providers` passes this same
 * instance to `QueryClientProvider`.
 */
export const queryClient = new QueryClient();
